import { render, staticRenderFns } from "./PolicyList.vue?vue&type=template&id=5c5de1c0&scoped=true"
import script from "./PolicyList.vue?vue&type=script&lang=js"
export * from "./PolicyList.vue?vue&type=script&lang=js"
import style0 from "./PolicyList.vue?vue&type=style&index=0&id=5c5de1c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5de1c0",
  null
  
)

export default component.exports